import { ReadEvent } from 'services/orchestration/EventFragment';
import { Resolvers } from 'apollo-client';

export const resolvers: Resolvers = {
  Mutation: {
    toggleEventRead: (_root, variables: { id: string }, { cache, getCacheKey }) => {
      const id = getCacheKey({ __typename: 'Event', id: variables.id });
      const fragment = ReadEvent;
      const event = cache.readFragment({ fragment, id });

      /**
       * Because we use two apollo clients and their interactions, sometimes events
       * can have already been ejected from the cache by the time this mutation triggers
       */
      if (event) {
        const data = { ...event, read: !event.read };
        cache.writeData({ id, data });
      }

      return null;
    }
  }
};
